<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-button size='small' @click="()=>{ $router.push({path:'/wxPublic/wxManagement/drewManagement',query:{active:3}})}">
        <LeftOutlined />返回 </a-button>
      <span class="ml15 fz-20">{{$route.query.type == 'add' ? '添加':'修改'}}小程序卡片</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="title" label="卡片标题" name="title">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.title" placeholder='请输入卡片标题' />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="appid" label="AppID" name="appid">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.appid" placeholder='请输入绑定公众号小程序的AppID' />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="url" label="页面路径" name="url" help="appid必须与关联的公众号一致，否则将无法通过公众号推送小程序卡片消息，请谨慎操作">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.url" placeholder='请输入小程序页面路径' />
            </a-col>
            <a-col :span="8">
              <a-button type="link">如何获取appid与页面路径？</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item class='m-t-15' ref="file_url" label="卡片封面" name="file_url" >
          <wxMaterial :groupType='1' :image="form.file_url" :max="1"
          v-on:handlechoose="(data)=>{form.file_url=data.imageUrl;form.thumb_media_id=data.data.media_id;}" v-on:handledel="form.thumb_media_id='';form.file_url=''" />
          <p>建议尺寸：900像素 * 500像素</p>
        </a-form-item>
         <a-form-item ref="" label="thumb_media_id" name="" hidden>
          <a-input v-model:value="form.thumb_media_id"  />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { LeftOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getTypeList } from "@/api/store";
  import { iscode } from "@/utils/app";
  import {getMiniCardMore,miniCardAdd,miniCardEdit} from '@/api/public_wx'
  // 初始化默认筛选项数值
  let defForm = {
    title:"",
    appid:'',
    url:'',
    thumb_media_id:'',
    file_url:''
  }
  export default {
    components: {LeftOutlined},
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        typeList:[],
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        rules: {
          title: [
            { required: true, message: '请输入卡片标题'}
          ],
          appid: [
            { required: true, message: '请输入AppID'}
          ],
          url: [
            { required: true, message: '请输入页面路径'}
          ],
          file_url:[
            {required: true, message: '请选择卡片封面'}
          ],
        }
      });
      const ruleForm = ref()
      const $route = inject('$route')
      const $router = inject('$router')
      const getMore = async(id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getMiniCardMore({id:id}).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          form.value.thumb_media_id = res.data.media_id
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if ($route.query.type == 'add') {
            res = await miniCardAdd(form.value).then(res => res.data);
          } else {
            res = await miniCardEdit({...form.value,id:$route.query.id}).then(res => res.data);
          }
              setTimeout(hide);
          if (iscode(res,true)) {
          $router.push({path:'/wxPublic/wxManagement/drewManagement',query:{active:3}});
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        if ($route.query.type == 'edit') {
          getMore($route.query.id);
        }
      });
      
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
